import React from "react";
import FirmStatsCards from "./models/firms_model/FirmStatsCards";
import FirmDashboardHeader from "./models/firms_model/FirmDashboardHeader";
import OrganizationHealth from "./models/firms_model/OrganizationHealth";
import DepartmentOverview from "./models/firms_model/DepartmentOverview";
import OfficeOverview from "./models/firms_model/OfficeOverview";
import RecentFirmActivity from "./models/firms_model/RecentFirmActivity";

const CAFirmDashboard = () => {
    return (
        <>
            <FirmDashboardHeader />
            <FirmStatsCards />

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "20px",
                    marginBottom: "20px",
                }}
            >
                <OrganizationHealth />
                <RecentFirmActivity />
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "20px",
                }}
            >
                <DepartmentOverview />
                <OfficeOverview />
            </div>

            {/* <FirmDashboardHeader />
            <FirmStatsCards />
            <OrganizationHealth />
            <DepartmentOverview />
            <OfficeOverview />
            <RecentFirmActivity /> */}
        </>
    );
};

export default CAFirmDashboard;
